import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Typography, HelperText } from '../../index'
import clsx from 'clsx'

import './DropdownItem.scss'
import withTheme from '../styles/withTheme'

/* @TODO
 * - poptypes
 */

const DropdownItem = forwardRef(function DropdownItem(props, ref) {
	const { children, component, className, helperText = null, value, disabled = false, ...other } = props

	const Component = component || 'li'

	return (
		<Component className={clsx('Vb-dropdown-item', className)} value={value} disabled={disabled} ref={ref} {...other}>
			{helperText ? (
				<div className="Vb-dropdown-item-group">
					<Typography className="Vb-dropdown-item__text" component="span">
						{children}
					</Typography>
					<HelperText className="Vb-dropdown-item__helper">{helperText}</HelperText>
				</div>
			) : (
				<Typography className="Vb-dropdown-item__text" component="span">
					{children}
				</Typography>
			)}
		</Component>
	)
})

export default withTheme('Vb-dropdown-item')(DropdownItem)
